import Collapse from "@kunukn/react-collapse";
import classNames from "classnames";
import React from "react";

interface Props {
  className?: string
  height?: number
  preview: JSX.Element
  fullView: JSX.Element
  style?: React.CSSProperties
  onlyShowFullView: boolean
}

const CollapsiblePreview = (props: Props) => {
  const [clickTime, setClickTime] = React.useState(0);
  const [collapsed, setCollapsed] = React.useState(true);
  const [hasFinishedCollapsing, setHasFinishedCollapsed] = React.useState(true);

  const onCollapsePress = () => {
    if (!hasFinishedCollapsing) return;
    setClickTime(new Date().valueOf());
  };

  const onCollapseRelease = () => {
    if (!hasFinishedCollapsing) return;

    const now = new Date().valueOf();
    if (now - clickTime < 250) {
      setCollapsed(!collapsed);
      setHasFinishedCollapsed(false);
    } else {
      setHasFinishedCollapsed(true);
    }

    setClickTime(0);
  };

  const onCollapseStateChange = (state) => {
    if (state === "expanded" || state === "collapsed") {
      setHasFinishedCollapsed(true);
    }
  };

  const bodyClasses = classNames("grow1 padding-left", props.className, {
    hoverable: !props.onlyShowFullView
  });

  const displayPreview = hasFinishedCollapsing && collapsed && !props.onlyShowFullView;
  const displayFull = !displayPreview;

  const height = props.height ? `${props.height}px` : "60px";

  return <div className={bodyClasses} onMouseDown={onCollapsePress} onMouseUp={onCollapseRelease} style={props.style}>

    <Collapse isOpen={!collapsed} onChange={({ state }) => { onCollapseStateChange(state); }} collapseHeight={height}>
      {displayPreview && props.preview}
      {displayFull && props.fullView}
    </Collapse>
  </div>;
};

export default CollapsiblePreview;